import React, { useState, useEffect, useRef } from "react";
import Group174img from "../../../pages/adminApplication/components/skillVideoTest/images/Group 174-disabled.png";
import Group175img from "../../../pages/adminApplication/components/skillVideoTest/images/Group 175.png";
import cross from "../../../pages/adminApplication/components/skillVideoTest/images/cross.svg";
import WarningIcon from "@mui/icons-material/Warning";
import "react-alice-carousel/lib/alice-carousel.css";
import AliceCarousel from "react-alice-carousel";
import incorrect from "../../../pages/adminApplication/components/skillVideoTest/images/incorrect.png";
import correct from "../../../pages/adminApplication/components/skillVideoTest/images/correct.png";
import Dialog from "@mui/material/Dialog";
import MuiDialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import Skeleton from "@mui/material/Skeleton";

import Button from "@mui/material/Button";
import SwipeableViews from "react-swipeable-views-react-18-fix";
import { autoPlay } from "react-swipeable-views-utils-react-18-fix";
import { useTheme } from '@mui/material/styles';
import Slide from "@mui/material/Slide";
import getUserTestByTestId from "../../../apis/userTest/userTestByTestId";
import getUserTestQuestionAnswer from "../../../apis/userTest/userTestQuestionAnswerByTestId";
import noVideo from "../../../pages/adminApplication/components/skillVideoTest/images/video_unavailable.png";
import getPublishedUserTests from "../../../apis/userTest/getPublishedUserTests";
import getAllUserTestsAdmin from "../../../apis/userTest/getAllUserTestsAdmin";
import getUsersById from "../../../apis/users/getUserById";
import testQuestionDescription from "../../../utilities/questionSyntaxHighlight";
// import Prism from "prismjs";
import { DateTime } from "luxon";
import ArrowBackIos from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';
import { styled } from '@mui/material/styles';

import Tooltip from '@mui/material/Tooltip';


let regionNames = new Intl.DisplayNames(['en'], { type: 'region' });
const getCountryName = (ct) => {
  try {
    if (regionNames.of(ct)) {
      return regionNames.of(ct)
    } else {
      return null
    }
  }
  catch (err) {
    return null
  }
}
const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});




const DialogContent = styled(MuiDialogContent)(({ theme }) => ({
  padding: theme.spacing(2),
}));


const CandidateTest = (props) => {
  let userId = localStorage.getItem("userID");
  const theme = useTheme();
  const [modalStatus, setModalStatus] = useState(false);
  const [questionIndex, setQuestionIndex] = useState(0);
  const [questionNumber, setQuestionNumber] = useState(1);
  const [totalQuestions, setTotalQuestions] = useState(0);
  const [totalCorrectAnswers, setTotalCorrectAnswers] = useState(0);
  const [questionTime, setQuestionTime] = useState("");
  const [answerTime, setAnswerTime] = useState("");
  const [userAnswersResponse, setUserAnswerResponse] = useState([]);
  const [userAnswerList, setUserAnswerList] = useState([]);
  const [skillTestDate, setSkillTestDate] = useState("");
  const [loadingController, setLoadingController] = useState(false);
  const [isSharebtnClicked, setisSharebtnClicked] = useState(false);
  const [showTextBox, setShowTextBox] = useState(false);
  const userAnswerResponseRef = useRef(0);
  const textAreaRef = useRef(null);
  const [userTestId, setuserTestId] = useState("");
  const [activeStep, setActiveStep] = React.useState(0);
  const [skillName, setSkillName] = useState("");
  const [violationDetails, setViolationDetails] = useState([]);
  const userRole =localStorage.getItem("role");
  const [user, setUser] = useState([]);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };


  const getAllUsersById = async () => {
    try {
      const response = await getUsersById(userId);
      setUser(response.data.data);
    } catch (err) {
      console.log("err", err);
    }
  };

  const getSkillName = async (testId) => {
    try {
      if (testId) {
        const userTestSkill = await getUserTestByTestId(testId);
        setuserTestId(userTestSkill.data.data.id);
        setSkillName(userTestSkill.data.data);
        const isViolationExist = userTestSkill?.data?.data?.violations?.length > 0
        if (isViolationExist) {
          setViolationDetails(userTestSkill?.data?.data?.violations)
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const sharebtnClickedHandler = (e) => {
    setisSharebtnClicked(true);
    textAreaRef.current.select();
    document.execCommand("copy");
    e.target.focus();
    setTimeout(sharebtnTxtChange, 5000);
  };
  const sharebtnTxtChange = () => {
    setisSharebtnClicked(false);
  };

  // Open Skill Test Modal
  const openSkilltestModal = async () => {
    await getTestDetails(
      userAnswersResponse[userAnswerResponseRef.current]
        ? userAnswersResponse[userAnswerResponseRef.current].id
          ? userAnswersResponse[userAnswerResponseRef.current].id
          : ""
        : ""
    );
    setModalStatus(true);
  };

  // Close Skill Test Modal
  const closeSkillTestModal = (event) => {
    setModalStatus(false);
  };

  // Toggle Questions
  const questionsHandler = (index) => {
    let inputCheckboxes = document.querySelectorAll(".clearcheckbox");
    for (let i = 0; i < inputCheckboxes.length; i++) {
      inputCheckboxes[i].checked = false;
    }
    setQuestionIndex(index);
    setQuestionNumber(index + 1);
  };

  // Get all user test
  const getUserTests = async () => {
    try {
      let role = localStorage.getItem("role");
      if (role === "Admin") {
        let userTestApiResponse = await getAllUserTestsAdmin(props.profileId);
        setUserAnswerResponse(userTestApiResponse.data.data);
      } else {
        let userTestApiResponse = await getPublishedUserTests(props.profileId);
        setUserAnswerResponse(userTestApiResponse.data.data);
      }

      setLoadingController(true);
    } catch (error) {
      console.log("%cError: " + error, "color:red;");
      setLoadingController(true);
    }
  };

  const questionCardSliderHandler = async (action) => {
    if (action === "increment") {
      handleNext();
      if (
        userAnswerResponseRef.current + 1 <= userAnswersResponse.length &&
        userAnswerResponseRef.current + 1 >= 0
      ) {
        userAnswerResponseRef.current = userAnswerResponseRef.current + 1;
        await getTestDetails(
          userAnswersResponse[userAnswerResponseRef.current]
            ? userAnswersResponse[userAnswerResponseRef.current].id
              ? userAnswersResponse[userAnswerResponseRef.current].id
              : ""
            : ""
        );
        await getSkillName(
          userAnswersResponse[userAnswerResponseRef.current]
            ? userAnswersResponse[userAnswerResponseRef.current].id
              ? userAnswersResponse[userAnswerResponseRef.current].id
              : ""
            : ""
        );
      }
    }
    if (action === "decrement") {
      handleBack();
      if (
        userAnswerResponseRef.current - 1 <= userAnswersResponse.length &&
        userAnswerResponseRef.current - 1 >= 0
      ) {
        userAnswerResponseRef.current = userAnswerResponseRef.current - 1;
        await getTestDetails(
          userAnswersResponse[userAnswerResponseRef.current]
            ? userAnswersResponse[userAnswerResponseRef.current].id
              ? userAnswersResponse[userAnswerResponseRef.current].id
              : ""
            : ""
        );

        await getSkillName(
          userAnswersResponse[userAnswerResponseRef.current]
            ? userAnswersResponse[userAnswerResponseRef.current].id
              ? userAnswersResponse[userAnswerResponseRef.current].id
              : ""
            : ""
        );
      }
    }
  };

  // Get Test Details
  const getTestDetails = async (testId) => {
    try {
      if (testId) {
        const userTestDetails = await getUserTestQuestionAnswer(testId);
        const tempUsersTestDetails = userTestDetails.data.data;

        let totalQuestionSecondsAlloted = 0;
        let totalQuestionMinutesAlloted = 0;
        tempUsersTestDetails.forEach((el) => {
          totalQuestionSecondsAlloted =
            totalQuestionSecondsAlloted +
            Number.parseInt(el.userTestQuestionQuestion.timeLimit);
        });
        if (totalQuestionSecondsAlloted > 60) {
          totalQuestionMinutesAlloted = totalQuestionSecondsAlloted / 60;
          const time =
            totalQuestionMinutesAlloted % 1 === 0
              ? totalQuestionMinutesAlloted
              : parseFloat(totalQuestionMinutesAlloted).toFixed(1);

          setQuestionTime(time + " Minutes");
        } else {
          setQuestionTime(totalQuestionSecondsAlloted + " Seconds");
        }

        let totalAnswerSecondsAlloted = 0;
        tempUsersTestDetails.forEach((el) => {
          totalAnswerSecondsAlloted =
            totalAnswerSecondsAlloted + Number.parseInt(el.userTimeTaken);
        });

        if (totalAnswerSecondsAlloted > 60) {
          let minute = ~~((totalAnswerSecondsAlloted % 3600) / 60);
          let second = totalAnswerSecondsAlloted % 60;
          setAnswerTime(
            minute +
            (minute === 1 ? " minute" : " minutes") +
            " " +
            second +
            " seconds"
          );
        } else {
          setAnswerTime(totalAnswerSecondsAlloted + " Seconds");
        }
        setTotalQuestions(tempUsersTestDetails.length);
        let userTestScore = 0;
        tempUsersTestDetails.forEach((el) => {
          if (el.isCorrect) {
            userTestScore = userTestScore + 1;
          }
        });
        setTotalCorrectAnswers(userTestScore);
        setSkillTestDate(
          DateTime.fromISO(tempUsersTestDetails[0].createdAt).toFormat(
            "LLL-dd-yyyy t"
          )
        );
        setUserAnswerList(userTestDetails.data.data);
      }
    } catch (error) {
      console.log("%cError: " + error, "color:red;");
    }
  };
  const minToSec = (timeLimit) => {
    let minutes = Math.floor(timeLimit / 60);
    let seconds = timeLimit - minutes * 60;
    return (
      minutes +
      (minutes === 1 ? " minute" : " minutes") +
      " " +
      (seconds < 10 ? "0" : "") +
      seconds +
      " seconds"
    );
  };


  useEffect(() => {
    getAllUsersById();
  }, []);

  // Use Effect Get Test
  useEffect(() => {
    if (props.profileId) {
      getUserTests();
    }
  }, [props.profileId]);

  // Use Effect Get Test Details
  useEffect(() => {
    getTestDetails(
      userAnswersResponse[0]
        ? userAnswersResponse[0].id
          ? userAnswersResponse[0].id
          : ""
        : ""
    );
    getSkillName(
      userAnswersResponse[0]
        ? userAnswersResponse[0].id
          ? userAnswersResponse[0].id
          : ""
        : ""
    );
  }, [userAnswersResponse]);

  const IsJsonString = (str) => {
    // alert("ok")
    try {
      var locationjson = JSON.parse(str);

      if (Object.keys(locationjson).length > 0) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
    // return true;
  };
  const responsive = {
    0: {
      items: 3,
    },
    600: {
      items: 3,
    },
    1024: {
      items: 12,
    },
  };

  // setTimeout(() => Prism.highlightAll(), 0);

  return (
    <>
      {loadingController ? (
        <>
          {userAnswersResponse && userAnswersResponse.length ? (
            <div>
              {userAnswerList.length > 0 ? (
                <div className="skillTestmain">
                  <div className="skillTestInfoContainer_poweResumeRight">
                    <AutoPlaySwipeableViews
                      axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                      index={activeStep}
                      //   sx={(theme) => ({
                      //   width: '99.9%'
                      //  })}
                    >
                      {userAnswersResponse.map((step, index) => (
                        <div key={index} className="skillVideoTestContentContainer_poweResumeRight">
                          <div className="SkillVideoTestTitleStatusContainer_poweResumeRight">
                            <span className="primarySkillTitle_poweResumeRight">Skill Video Test</span>
                            <div className={step.userTestTestStatus.code === "completed" ? "videoSKillTestStatus_poweResumeRight_completed" : "videoSKillTestStatus_poweResumeRight_missing"}>
                              {step.userTestTestStatus.code === "completed"
                                ? "Completed"
                                : "Exited before completion"}
                            </div>
                          </div>
                          {Math.abs(activeStep - index) <= 2 ? (<>
                            <span className="skillTestName_poweResumeRight">{step?.test?.testName}
                              {step?.test?.testCode &&
                                `(${step?.test?.testCode})`}
                            </span>
                            <div className="skillTestTimeInfoContainer_poweResumeRight">
                              <span>Skill test taken on: {DateTime.fromISO(
                                step.createdAt
                              ).toFormat("dd-LLL-yyyy")}
                              </span>
                              <span>Skill test duration: {questionTime}</span>
                              <span>User time taken: {answerTime}</span>
                            </div>
                            <div className="testScoreContainer_poweResumeRight">
                              <span>Total Questions: {totalQuestions}</span>
                              <span>Skill test score {totalCorrectAnswers} out of {totalQuestions}</span>
                            </div>
                            {userRole === "Candidate" ||
                              userRole === null ? (
                              <></>
                            ) : (
                              (userRole === 'Admin' || step?.test?.recruitmentpartnerId ===
                                "" ||
                                (user[0]?.recruitmentpartnerId ===
                                  step?.test?.recruitmentpartnerId &&
                                  typeof step?.test
                                    ?.recruitmentpartnerId !==
                                  "undefined")) && (
                                <div className="skillVideoTestestbtnContainer_poweResumeRight">
                                  <div className="add_email_box_skillvideo_test mt_33">
                                    <input
                                      type="text"
                                      className="search-input"
                                      value={
                                        "https://" +
                                        window.location.host +
                                        "/test/" +
                                        userTestId
                                      }
                                      ref={textAreaRef}
                                      readOnly
                                    />
                                    <Button
                                      className="viewSkillTestBtn_poweResumeRight_copyLink"
                                      onClick={(e) =>
                                        sharebtnClickedHandler(e)
                                      }
                                    >
                                      {isSharebtnClicked
                                        ? "Copied"
                                        : "Copy Link"}
                                    </Button>
                                  </div>
                                  <div className="skill_video_test_btnsection">
                                    <Button
                                      type="button"
                                      className="viewSkillTestBtn_poweResumeRight"
                                      onClick={(e) =>
                                        openSkilltestModal(e)
                                      }
                                    >
                                      View Skill Test
                                    </Button>
                                  </div>
                                </div>
                              )
                            )}
                          </>
                          ) : null}
                        </div>
                      ))}
                    </AutoPlaySwipeableViews>
                    <div className="additionalSKillScroll_poweResumeRight">
                      <IconButton className="arraowIconContainer_powerResumeRight" onClick={() => questionCardSliderHandler("decrement")} disabled={activeStep === 0}><ArrowBackIos className="arraowIcon_powerResumeRight" /></IconButton>
                      <div className="skillItemCountContainer_poweResumeRight">{activeStep + 1}<span className="skillItemCountContainer_poweResumeRight_opacity"> out of {userAnswersResponse.length}</span></div>
                      <IconButton className="arraowIconContainer_powerResumeRight" onClick={() => questionCardSliderHandler("increment")} disabled={activeStep === userAnswersResponse.length - 1}><ArrowForwardIos className="arraowIcon_powerResumeRight" /></IconButton>
                    </div>
                  </div>
                </div>


              ) :
                <div className="skillVideoTestContentContainer_poweResumeRight">
                  <div className="SkillVideoTestTitleStatusContainer_poweResumeRight">
                    <span className="primarySkillTitle_poweResumeRight">Skill Video Test</span>
                    <Skeleton variant="rect" animation="wave" height={30} width={150} />
                  </div>
                  <Skeleton variant="rect" animation="wave" height={15} width={100} />
                  <div className="skillTestTimeInfoContainer_poweResumeRight">
                    <Skeleton variant="rect" animation="wave" height={12} width={150} />
                    <Skeleton variant="rect" animation="wave" height={12} width={150} />
                    <Skeleton variant="rect" animation="wave" height={12} width={150} />
                  </div>
                  <div className="testScoreContainer_poweResumeRight">
                    <Skeleton variant="rect" animation="wave" height={12} width={150} />
                    <Skeleton variant="rect" animation="wave" height={12} width={150} />
                  </div>
                  <div className="skillVideoTestestbtnContainer_poweResumeRight">
                    <Skeleton variant="rect" animation="wave" height={30} width="75%" />
                    <Skeleton variant="rect" animation="wave" height={30} width={100} />
                  </div>
                  <div className="additionalSKillScroll_poweResumeRight">
                    <Skeleton variant="circle" animation="wave" height={24} width={24} />
                    <Skeleton variant="react" animation="wave" height={24} width={120} />
                    <Skeleton variant="circle" animation="wave" height={24} width={24} />
                  </div>

                </div>
              }

            </div>
          ) : (
            <div className="card mt_10">
              <div className="row">
                <p className="fs-light fs-35 f-color">Skill Test</p>
                <p className="fs-regular fs-16 mt_12">
                  No skill tests available
                </p>
              </div>
            </div>
          )}
        </>
      ) : (
        <div className="skillVideoTestContentContainer_poweResumeRight">
          <div className="SkillVideoTestTitleStatusContainer_poweResumeRight">
            <span className="primarySkillTitle_poweResumeRight">Skill Video Test</span>
            <Skeleton variant="rect" animation="wave" height={30} width={150} />
          </div>
          <Skeleton variant="rect" animation="wave" height={15} width={100} />
          <div className="skillTestTimeInfoContainer_poweResumeRight">
            <Skeleton variant="rect" animation="wave" height={12} width={150} />
            <Skeleton variant="rect" animation="wave" height={12} width={150} />
            <Skeleton variant="rect" animation="wave" height={12} width={150} />
          </div>
          <div className="testScoreContainer_poweResumeRight">
            <Skeleton variant="rect" animation="wave" height={12} width={150} />
            <Skeleton variant="rect" animation="wave" height={12} width={150} />
          </div>
          <div className="skillVideoTestestbtnContainer_poweResumeRight">
            <Skeleton variant="rect" animation="wave" height={30} width={500} />
            <Skeleton variant="rect" animation="wave" height={30} width={100} />
          </div>
          <div className="additionalSKillScroll_poweResumeRight">
            <Skeleton variant="circle" animation="wave" height={24} width={24} />
            <Skeleton variant="react" animation="wave" height={24} width={120} />
            <Skeleton variant="circle" animation="wave" height={24} width={24} />
          </div>

        </div>
      )}
      <Dialog
        fullScreen
        open={modalStatus}
        onClose={closeSkillTestModal}
        aria-labelledby="customized-dialog-title"
        TransitionComponent={Transition}
        // maxWidth="sm"
        //  fullWidth={true}
        className="fullscreen-width full_screen_from_top"
      >
        {/* <DialogTitle onClose={closeSkillTestModal}>Skill Video Test</DialogTitle> */}
        <div
          className="skill-video-crossFormodal"
          onClick={closeSkillTestModal}
        >
          <img className="closeicon_set" src={cross} alt=""></img>
        </div>
        <DialogContent className="mt_20">
          <div className="playbuttonsection">
            {/* <div>
                      <img src={Group121} alt="" className="playButton" />
                    </div> */}
            <div>
              <p className="fs-semi-bold fs-16 f-color mb_3">
                {/* React Native - Advance coding test */}
                {skillName?.test?.testName}
              </p>
              <p className="fs-regular fs-14 f-color mb_3">
                Skill Test Taken On: {skillTestDate}
              </p>
              <p className="fs-regular fs-14 f-color mb_3">
                Skill Test Duration: {questionTime}
              </p>
              <p className="fs-regular fs-14 f-color mb_3">
                Time Taken By Candidate: {answerTime}
              </p>
            </div>

            <div className="accenture-data df view_test"  >
              <div className="cadidateinfo_clm_one">
                <p className="fs-regular fs-14 f-color mb_3">
                  First Name: {props.profileData.user?.firstName}
                </p>
                <p className="fs-regular fs-14 f-color mb_3">
                  Last Name: {props.profileData.user?.lastName}
                </p>
                <p className="fs-regular fs-14 f-color mb_3">
                  Email: {props.profileData.user?.email}
                </p>
              </div>
              <div className="cadidateinfo_clm_two">
                <p className="fs-regular fs-14 f-color mb_3">
                  Country:{" "}
                  {props.profileData.locationCountry
                    ? IsJsonString(props.profileData.locationCountry)
                      ? JSON.parse(props.profileData.locationCountry)
                        .name
                      : ""
                    : ""}
                </p>
                <p className="fs-regular fs-14 f-color mb_3">
                  State:{" "}
                  {props.profileData.locationState
                    ? IsJsonString(props.profileData.locationState)
                      ? JSON.parse(props.profileData.locationState).name
                      : ""
                    : ""}
                </p>
                {props.profileData.locationCity && (
                  <p className="fs-regular fs-14 f-color mb_3">
                    City:{" "}
                    {props.profileData.locationCity
                      ? IsJsonString(props.profileData.locationCity)
                        ? JSON.parse(props.profileData.locationCity)
                          .name
                        : ""
                      : ""}
                  </p>
                )}
              </div>
              <div className="cadidateinfo_clm_two">
                <p className="fs-regular fs-14 f-color mb_3">
                  Assessment Country: {" "}
                  <span className={props.profileData.locationCountry
                    && IsJsonString(props.profileData.locationCountry)
                    && JSON.parse(props.profileData.locationCountry).isoCode === skillName.assessmentCountryCode ? '' : 'f-red'} >{getCountryName(skillName.assessmentCountryCode) ? getCountryName(skillName.assessmentCountryCode) : (skillName.assessmentCountryCode || "Not found")} </span>
                </p>
              </div>
            </div>
          </div>
          <hr className="new1" />
          <p className="fs-semi-bold fs-16 f-color">Score Card</p>
          <div className="scorecardsection">
            <div>
              <p className="fs-regular fs-14 f-color">Total Questions</p>
              <p className="fs-semi-bold fs-18">{totalQuestions}</p>
            </div>

            <div className="ml_41">
              <p className="fs-regular fs-14 f-color">Total Correct Answers</p>
              <div className="flex items-center flex-wrap">
                <span className="fs-semi-bold fs-18 green_text">{totalCorrectAnswers}</span>
                <span className="fs-regular fs-18 ml_5">out of</span>
                <span className="fs-semi-bold fs-18 ml_5">{totalQuestions}</span>
              </div>
            </div>

            <div className="ml_41">
              <p className="fs-regular fs-14 f-color">Skill Test Score</p>
              <div className="flex items-center flex-wrap">
                <span className="fs-semi-bold fs-18 green_text">{totalCorrectAnswers}</span>
                <span className="fs-regular fs-18 ml_5">out of</span>
                <span className="fs-semi-bold fs-18 ml_5">{totalQuestions}</span>
              </div>
            </div>


            <div className="ml_41">
              <p className="fs-regular fs-14 f-color flex items-center mr_10 mb_1">
                Number of Violations
                {violationDetails.length > 0 && <Tooltip title="Click to view violation details" arrow>
                  <WarningIcon
                    style={{
                      color: 'red',
                      width: '20px',
                      height: '20px',
                      cursor: 'pointer',
                      verticalAlign: 'middle',
                    }}
                    onClick={() => setShowTextBox(!showTextBox)}
                  />
                </Tooltip>}
              </p>
              <span className="fs-semi-bold fs-18 green_text">
                {
                  violationDetails
                    .filter((violation) => violation.questionNumber !== null).length || 0
                }
              </span>
            </div>


            {showTextBox && (
              <textarea
                disabled
                style={{
                  width: '420px',
                  height: 'auto',
                  padding: '8px',
                  fontSize: '16px',
                }}
                defaultValue={violationDetails
                  .filter((violation) => violation.questionNumber !== null)
                  .sort((a, b) => a.questionNumber - b.questionNumber) // Sort by questionNumber
                  .map((violation, index) => {
                    const totalSeconds = violation.violationTime;
                    const minutes = Math.floor(totalSeconds / 60);
                    const seconds = totalSeconds % 60;

                    const timeFormatted =
                      minutes > 0
                        ? `${minutes} min${minutes > 1 ? 's' : ''} ${seconds} sec${seconds !== 1 ? 's' : ''}`
                        : `${seconds} sec${seconds !== 1 ? 's' : ''}`;

                    return `${index + 1}. ${violation.violationType} on Question ${violation.questionNumber} for ${timeFormatted}.`;
                  })
                  .join('\n')}
              />
            )}


          </div>

          <hr className="new1 " />
          <p className="fs-semi-bold fs-16 f-color">Questions</p>

          <div className="row mt_17">
            <AliceCarousel responsive={responsive}>
              {userAnswerList.map((question, index) =>
                userAnswerList[Number(index)]
                  ?.userTestQuestionUserTestQuestionAnswer?.length ===
                  0 ? (
                  <button
                    type="button"
                    className={
                      questionIndex === index
                        ? "btnquestion btnquestion-questionselected  cp"
                        : "btnquestion btnquestion-questiondisable  cp"
                    }
                    key={index}
                    onClick={() => questionsHandler(index)}
                  >
                    <span>{index + 1}</span>
                    <span className="btn-icon">
                      <img
                        src={
                          questionIndex === index
                            ? Group175img
                            : Group174img
                        }
                        alt=""
                      />
                    </span>
                  </button>
                ) : question.isCorrect === true ? (
                  <button
                    type="button"
                    className={
                      questionIndex === index
                        ? "btnquestion btnquestion-questionselected  cp"
                        : "btnquestion btnquestion-questionright  cp"
                    }
                    key={index}
                    onClick={() => questionsHandler(index)}
                  >
                    <span>{index + 1}</span>
                    <span className="btn-icon">
                      <img src={Group175img} alt="" />
                    </span>
                  </button>
                ) : question.isCorrect === false ? (
                  <button
                    type="button"
                    className={
                      questionIndex === index
                        ? "btnquestion btnquestion-questionselected  cp"
                        : "btnquestion btnquestion-questionwrong  cp"
                    }
                    key={index}
                    onClick={() => questionsHandler(index)}
                  >
                    <span>{index + 1}</span>
                    <span className="btn-icon">
                      <img src={Group175img} alt="" />
                    </span>
                  </button>
                ) : (
                  <button
                    type="button"
                    className={
                      questionIndex === index
                        ? "btnquestion btnquestion-questionselected  cp"
                        : "btnquestion btnquestion-questiondisable  cp"
                    }
                    key={index}
                    onClick={() => questionsHandler(index)}
                  >
                    <span>{index + 1}</span>
                    <span className="btn-icon">
                      <img src={Group175img} alt="" />
                    </span>
                  </button>
                )
              )}
            </AliceCarousel>
          </div>
          <hr className="new1 mt_17" />
          <div className="row df skillvideo_btm_adjust">
            <div className="mw">
              <div className="df">
                <div>
                  <p className="fs-regular fs-14 f-color mr_10">
                    Video response time limit:
                  </p>
                  <p className="fs-semi-bold fs-16 f-color">
                    Response time:
                  </p>
                </div>

                <div>
                  <p className="fs-regular fs-14 f-color">
                    {/* <span className="time_icon">
                              <img src={timerImage} />
                            </span> */}
                    {/* {userAnswerList[questionIndex]?.userTestQuestionQuestion
                              ?.timeLimit + " seconds"} */}
                    {minToSec(
                      userAnswerList[questionIndex]
                        ?.userTestQuestionQuestion?.timeLimit
                    )}
                  </p>
                  <p className="fs-semi-bold fs-14 f-color">
                    {userAnswerList[questionIndex]?.userTimeTaken +
                      " seconds"}
                  </p>
                </div>
              </div>
              {userAnswersResponse.filter(
                (item) =>
                  item.id === userAnswerList[questionIndex]?.userTestId
              )[0]?.isDeleted ? (
                <video
                  autoplay
                  // src={
                  //   noVideo
                  // }
                  className="video-interview-test mt_17"
                  controls={true}
                  poster={noVideo}
                />
              ) : (
                <video
                  autoplay
                  src={
                    userAnswerList
                      ? userAnswerList.length > 0
                        ? userAnswerList[questionIndex]
                          ? userAnswerList[questionIndex].videoURL
                            ? userAnswerList[questionIndex].videoURL
                            : ""
                          : ""
                        : ""
                      : ""
                  }
                  className="video-interview-test mt_17"
                  controls={true}
                />
              )}
            </div>
            <div className="vl"></div>
            <div className="mw ml_22 scrollHeight1 viewtestresults-questionsides interview-question-scroll1">
              <div className="fs-semi-ui-class fs-16 f-color videobuttomquestion">
                <span className="fs-20">Q.{questionNumber}</span>
                <span className="pt_4  pl_6" id="testQuestionDescp">

                  {testQuestionDescription(
                    userAnswerList[Number(questionIndex)]
                      ? userAnswerList[Number(questionIndex)]
                        .userTestQuestionQuestion.questionDesc
                      : ""
                  )}
                </span>
              </div>
              {userAnswerList[questionIndex]
                ? userAnswerList[questionIndex].questionimg === ""
                  ? ""
                  :
                  null
                : null}
              {userAnswerList[questionIndex]
                ? userAnswerList[questionIndex].userTestQuestionQuestion
                  ? userAnswerList[questionIndex]
                    .userTestQuestionQuestion.questionAnswer
                    ? userAnswerList[questionIndex]
                      .userTestQuestionQuestion.questionAnswer
                      .length > 0
                      ? userAnswerList[
                        questionIndex
                      ].userTestQuestionQuestion.questionAnswer.map(
                        (options, index) => (
                          <p
                            className={
                              userAnswerList[
                                Number(questionIndex)
                              ]?.userTestQuestionUserTestQuestionAnswer.find(
                                (el) =>
                                  el.userTestQuestionAnswerAnswer
                                    .isCorrect === true
                              )
                                ? "questionoption questionoption-alignment right-question-option"
                                : "questionoption questionoption-alignment wrong-question-option"
                            }
                            key={"v-ops-" + index}
                          >
                            {userAnswerList[Number(questionIndex)]
                              .userTestQuestionQuestion
                              .questionAnswertype.code ===
                              "SingleChoice" ? (
                              <>
                                <input
                                  type="radio"
                                  name="radio-group"
                                  id={options.id + "-radio-" + index}
                                  checked={
                                    userAnswerList[
                                      Number(questionIndex)
                                    ]
                                      ?.userTestQuestionUserTestQuestionAnswer[0]
                                      ?.answerId === options.id
                                  }
                                  //  == userAnswerList[Number(questionIndex)].userTestQuestionUserTestQuestionAnswer[0].id
                                  value={options.id}
                                  disabled={true}
                                />
                                <label
                                  htmlhtmlFor={options.id}
                                  className="fs-semi-ui-class fs-18 f-color"
                                >
                                  <div>
                                    {options.answerText &&
                                      options.answerText.includes("\n")
                                      ? options.answerText
                                        .split("\n")
                                        .map((item, idx) => (
                                          <p
                                            key={idx}
                                            className="without-linebreak"
                                            dangerouslySetInnerHTML={{
                                              __html: item
                                            }}
                                          >
                                          </p>
                                        ))
                                      : options.answerText
                                        .split("\\n")
                                        .map((item, idx) => (
                                          <span
                                            key={idx}
                                            className="without-linebreak"
                                            dangerouslySetInnerHTML={{
                                              __html: item
                                            }}
                                          >
                                          </span>
                                        ))}
                                  </div>
                                </label>
                              </>
                            ) : (
                              <div className="checkAnswer">
                                <form>
                                  <div className="interview-chkbox">
                                    <input
                                      type="checkbox"
                                      className={
                                        userAnswerList[
                                          Number(questionIndex)
                                        ].isCorrect
                                          ? "right-checkbox clearcheckbox"
                                          : "wrong-checkbox clearcheckbox"
                                      }
                                      id={
                                        options.id +
                                        "-checkbox-" +
                                        index
                                      }
                                      checked={userAnswerList[
                                        Number(questionIndex)
                                      ].userTestQuestionUserTestQuestionAnswer.find(
                                        (el) =>
                                          el.answerId === options.id
                                      )}
                                      value={options.id}
                                      disabled={true}
                                    />
                                    <label htmlFor={options.id} className="optionAlignment">
                                      <div>
                                        {options.answerText &&
                                          options.answerText.includes(
                                            "\n"
                                          )
                                          ? options.answerText
                                            .split("\n")
                                            .map((item, idx) => (
                                              <p
                                                key={idx}
                                                className="without-linebreak"
                                                dangerouslySetInnerHTML={{
                                                  __html: item
                                                }}
                                              ></p>
                                            ))
                                          : options.answerText
                                            .split("\\n")
                                            .map((item, idx) => (
                                              <span
                                                key={idx}
                                                className="without-linebreak"
                                                dangerouslySetInnerHTML={{
                                                  __html: item
                                                }}
                                              >
                                              </span>
                                            ))}
                                      </div>
                                    </label>
                                  </div>
                                </form>
                              </div>
                            )}
                          </p>
                        )
                      )
                      : null
                    : null
                  : null
                : null}
              {userAnswerList[Number(questionIndex)] ? (
                userAnswerList[Number(questionIndex)].isCorrect ? (
                  <div className="mt_17">
                    {userAnswerList[Number(questionIndex)]
                      ?.isCorrect === true ? (
                      <img src={correct}  alt="correct"/>
                    ) : null}
                  </div>
                ) : (
                  <div className="mt_17">
                    {userAnswerList[Number(questionIndex)]
                      ?.isCorrect === false ? (
                      <img src={incorrect} alt="incorrect" />
                    ) : null}
                  </div>
                )
              ) : null}
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CandidateTest;

